export enum CreatePageType {
  Video = 'video',
  ContentLink = 'contentLinkBlock',
  Editor = 'editorBlock',
}
